import API from "..";

export default class SDSRequestStatus {

  constructor({
    statusName,
    isActive,
    displayOrder
  }) 
    
  {
    this.statusName = statusName;
    this.isActive = isActive;
    this.displayOrder = displayOrder
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/sdsRequestStatus`);
    if (data.result) {
        return data.result.map((d) => new SDSRequestStatus(d));
    }
    else {
        return [];
    }
  }
}
